export default function handlePostRedirect(
  location: string,
  mount: HTMLElement,
  parameters: Record<string, string> = {},
): void {
  const form = document.createElement('form');
  form.setAttribute('method', 'POST');
  form.setAttribute('action', location);

  Object.keys(parameters).forEach((key) => {
    const value = parameters[key];
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', key);
    input.setAttribute('value', value);
    form.appendChild(input);
  });

  mount.appendChild(form);

  form.submit();
}
